import merge from 'lodash-es/merge';
import get from 'lodash-es/get';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultControlStyle(control, options) {
  const instance = control.instance;
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  if (!getDefaultControlStyle[control.designMode]) {
    getDefaultControlStyle[control.designMode]={};
  }

  

  if (!getDefaultControlStyle[instance.args.designMode][design]) {
    getDefaultControlStyle[instance.args.designMode][design] = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        boxSizing: 'border-box',
        top: '8px',
        left: '8px',
        width: '192px',
        height: '32px',
        display: 'inline-block',
        margin: '0px',
      }),
      hover: {},
      body: {
        normal: merge({}, getDefaultStyle(), {
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          padding: '2px 4px 0px 4px',
          fontSize: '${schemeFontSize}',
          color: '#000000',
          backgroundColor: '${schemeForeground}',
          margin: '0px',
          borderStyle: 'solid',
          borderColor: '${schemeShade}',
          borderWidth: design=='classic'?'3px':'1px',
          boxShadow: '0px 0px 4px ${schemeShade}',
          position: 'absolute',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          height: '100%',
          width: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }),
        hover: {},
        focused: {
          boxShadow: '0px 0px 4px ${schemeBackground} inset',
        },
      },
    };
  }

  if (options.valueType !== 'text') {
    getDefaultControlStyle[instance.args.designMode][design] .body.normal.padding = '0px';
  }

  return getDefaultControlStyle[instance.args.designMode][design];
}

export function getDefaultControl(instance, options) {
  var res = document.createElement('div');
  res.classList.add('controls');
  if (options.multiline) {
    res.innerHTML = '<textarea class="body">';
  } else {
    res.innerHTML = '<input class="body" type="' + options.valueType + '">';
  }

  return res;
}
